(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kira-wig-product-media"] && !Shopify.designMode) return;
  try {
    function initKiraLife(scope) {
    scope.querySelectorAll('[data-kw-life-carousel]').forEach(function(frame) {
      if (frame.dataset.kwLifeReady) return;
      frame.dataset.kwLifeReady = 'true';
      const track = frame.querySelector('.kw-life-track');
      const buttons = frame.querySelectorAll('[data-kw-life-step]');
      const update = function() {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach(function(button) { button.disabled = Number(button.dataset.kwLifeStep) < 0 ? index === 0 : index >= track.children.length - 1; });
      };
      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          const index = Math.round(track.scrollLeft / track.clientWidth) + Number(button.dataset.kwLifeStep);
          track.scrollTo({left:index * track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
      });
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initKiraLife(document);
  document.addEventListener('DOMContentLoaded', function() { initKiraLife(document); });
  document.addEventListener('shopify:section:load', function(event) { initKiraLife(event.target); });
  } catch(e) { console.error(e); }
})();

})();
